var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfessionalrole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(-1568 -654)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(1568 654)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1b530b9de04e58876273ff0135e159cb",
    "data-name": "1b530b9de04e58876273ff0135e159cb",
    transform: "translate(1569.328 656.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M-2.087,21.874h24.1V-1.441",
    transform: "translate(9.493 9.539)",
    fill: "none",
    stroke: "#3666f6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M0,23.315H24.1V0",
    transform: "translate(55.599 54.727) rotate(180)",
    fill: "none",
    stroke: "#3666f6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M5.237,0A5.237,5.237,0,1,1,0,5.237,5.237,5.237,0,0,1,5.237,0Z",
    transform: "translate(31.412 0) rotate(45)",
    fill: "#e2eaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M8.94,1.534A5.237,5.237,0,1,1,5.237,0,5.221,5.221,0,0,1,8.94,1.534Z",
    transform: "translate(7.407 24.005) rotate(45)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M5.238,0a5.238,5.238,0,1,1-3.7,1.534A5.237,5.237,0,0,1,5.238,0Z",
    transform: "translate(31.412 48.011) rotate(45)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M5.238,0A5.237,5.237,0,1,1,0,5.237,5.237,5.237,0,0,1,5.238,0Z",
    transform: "translate(55.417 24.006) rotate(45)",
    fill: "#dbf6e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M108.338,87.455a14.766,14.766,0,1,0-18.6,22.754,25.892,25.892,0,0,0,16.309,0,14.768,14.768,0,0,0,2.287-22.754Z",
    transform: "translate(-66.484 -66.484)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M166.954,279.027a.67.67,0,0,1-.186-.456v-.721h-3.326v.721a.779.779,0,0,1,0,.08c-.2,1.6-6.487,1.109-6.487,8.838a14.776,14.776,0,0,0,16.309,0C173.259,280.43,168.017,280.228,166.954,279.027Z",
    transform: "translate(-133.693 -243.764)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M202.185,141.13c4.614,0,4.507,4.368,4.507,6.611a6.2,6.2,0,0,1-2.844,5.634,3.336,3.336,0,0,1-3.326,0,6.2,6.2,0,0,1-2.844-5.634C197.678,145.5,197.57,141.13,202.185,141.13Z",
    transform: "translate(-170.773 -119.289)",
    fill: "#3666f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M189.548,347.9a.358.358,0,0,0-.358.358v3.1a.358.358,0,1,0,.716,0v-3.1A.358.358,0,0,0,189.548,347.9Zm9.818,0a.358.358,0,0,0-.358.358v3.1a.358.358,0,1,0,.717,0v-3.1A.358.358,0,0,0,199.366,347.9Z",
    transform: "translate(-163.045 -307.54)",
    fill: "#daf1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M232.9,279.027a6.918,6.918,0,0,1-3.517-.376.779.779,0,0,0,0-.08v-.721a3.335,3.335,0,0,0,3.326,0v.721A.67.67,0,0,0,232.9,279.027Z",
    transform: "translate(-199.636 -243.764)",
    fill: "#3666f6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalrole);
export default __webpack_public_path__ + "static/media/professionalrole.0d85715d9f0571e431cf85bb0a4ceb2c.svg";
export { ForwardRef as ReactComponent };